import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { transformCivilStatus } from 'shell/utils/consult-person/response-transformer/marital-status/civil-status';
import { RegistrationWidowhoodFormVM } from 'mutation/view-models/registration-widowhood';
import { CivilStatusID } from 'shell/constants/civil-status';
import { DateTime } from 'luxon';
import { transformMarriageActAnpr05 } from 'shell/utils/consult-person/response-transformer/marital-status/marriage-act-anpr05';
import { transformCivilUnionActAnpr05 } from 'shell/utils/consult-person/response-transformer/marital-status/civil-union-act-anpr05';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { ActType } from 'shell/constants/act-type';
import { transformDeathActAnpr05 } from 'shell/utils/consult-person/response-transformer/data-deletion/death-data-act-anpr05';
import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';

export const checkPersonRegistrationWidowhood = (civilStatus: string | undefined): boolean => {
  if (
    civilStatus &&
    civilStatus !== CivilStatusID.coniugato &&
    civilStatus !== CivilStatusID.unitoCivilmente
  ) {
    return false;
  }

  return true;
};

export const transformerRegistrationWidowhood = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): RegistrationWidowhoodFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person);

  const familyCoexistence = transformFamilyCoexistence(person);

  const citizenship = transformCitizenship(person);

  const civilStatus = transformCivilStatus(person);

  const marriage = transformMarriageActAnpr05(person);

  const civilUnion = transformCivilUnionActAnpr05(person);

  const widowhood = transformDeathActAnpr05(person);

  let status = CivilStatusID.vedovo;

  if (civilStatus?.status === CivilStatusID.unitoCivilmente) {
    status = CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso;
  }

  return {
    subjectData: person,
    person: personData,
    familyCoexistence,
    citizenship,
    civilUnion: civilUnion,
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    civilStatus: {
      ...(civilStatus || {}),
      oldStatus: civilStatus?.status,
      status,
    },
    marriage,
    widowhood: {
      paper: emptyPaper,
      digital: emptyDigital,
      actType: ActType.AttoCartaceo,
      eventDate: null,
      isForeign: false,
      exceptionalPlace: '',
      municipality: null,
      foreignState: null,
      foreignMunicipality: null,
      ...(widowhood || {}),
    },
  };
};
